import React from "react";
import { Outlet } from "react-router-dom";
import BusinessLayout from "../components/Layout/BusinessLayout";

export default function BusinessProtectedLayout() {
  return (
    <BusinessLayout>
      <Outlet />
    </BusinessLayout>
  );
}
